// extracted by mini-css-extract-plugin
export default {"CompanyPlanSubscriptionSection":"A94L2hUeNgCT84aq55zV"};